var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "rv2-welcome-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "rv2-welcome-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "rv2-welcome-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _vm.dismissible
                ? _c(
                    "button",
                    {
                      staticClass: "rv2-welcome-close",
                      attrs: { type: "button", "aria-label": "Close" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v(" × ")]
                  )
                : _vm._e(),
              _vm._m(0),
              _c("div", { staticClass: "rv2-welcome-body" }, [
                _c(
                  "section",
                  {
                    staticClass: "rv2-welcome-section",
                    attrs: { "aria-labelledby": "rv2-welcome-search-title" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "rv2-welcome-option rv2-welcome-search-wrapper",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "rv2-welcome-option-title",
                            attrs: { id: "rv2-welcome-search-title" },
                          },
                          [_vm._v(" Search gene or mechanism ")]
                        ),
                        _vm._m(1),
                        _c("div", { staticClass: "rv2-welcome-search-row" }, [
                          _c("div", { staticClass: "rv2-welcome-ac" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.searchText,
                                  expression: "searchText",
                                },
                              ],
                              ref: "searchInput",
                              staticClass: "rv2-welcome-input",
                              attrs: {
                                type: "text",
                                placeholder:
                                  "e.g. FANCA or proximal tubule transport",
                                autocomplete: "off",
                                "aria-autocomplete": "list",
                                "aria-expanded": _vm.showSuggestions
                                  ? "true"
                                  : "false",
                              },
                              domProps: { value: _vm.searchText },
                              on: {
                                input: [
                                  function ($event) {
                                    if ($event.target.composing) return
                                    _vm.searchText = $event.target.value
                                  },
                                  _vm.onSearchInput,
                                ],
                                keydown: [
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "down",
                                        40,
                                        $event.key,
                                        ["Down", "ArrowDown"]
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                    return _vm.moveHighlight(1)
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "up",
                                        38,
                                        $event.key,
                                        ["Up", "ArrowUp"]
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                    return _vm.moveHighlight(-1)
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                    return _vm.onSearchEnter.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                    return _vm.closeSuggestions.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                ],
                                focus: _vm.onSearchFocus,
                              },
                            }),
                            _vm.showSuggestions
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "rv2-welcome-suggestions",
                                    attrs: { role: "listbox" },
                                  },
                                  [
                                    _vm.suggestionsLoading
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "rv2-welcome-sug-status",
                                          },
                                          [_vm._v(" Searching… ")]
                                        )
                                      : [
                                          _vm.geneSuggestions.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "rv2-welcome-sug-group",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "rv2-welcome-sug-heading",
                                                    },
                                                    [_vm._v("Genes")]
                                                  ),
                                                  _vm._l(
                                                    _vm.geneSuggestions,
                                                    function (item, index) {
                                                      return _c(
                                                        "button",
                                                        {
                                                          key: `gene-${item.id}`,
                                                          staticClass:
                                                            "rv2-welcome-sug-item",
                                                          class: {
                                                            "is-active":
                                                              _vm.isHighlighted(
                                                                "gene",
                                                                index
                                                              ),
                                                          },
                                                          attrs: {
                                                            type: "button",
                                                            role: "option",
                                                          },
                                                          on: {
                                                            mousedown:
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.selectSuggestion(
                                                                  item
                                                                )
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "rv2-welcome-sug-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.label
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "rv2-welcome-sug-kind",
                                                            },
                                                            [_vm._v("Gene")]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          _vm.mechanismSuggestions.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "rv2-welcome-sug-group",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "rv2-welcome-sug-heading",
                                                    },
                                                    [_vm._v("Mechanisms")]
                                                  ),
                                                  _vm._l(
                                                    _vm.mechanismSuggestions,
                                                    function (item, index) {
                                                      return _c(
                                                        "button",
                                                        {
                                                          key: `mech-${item.id}`,
                                                          staticClass:
                                                            "rv2-welcome-sug-item",
                                                          class: {
                                                            "is-active":
                                                              _vm.isHighlighted(
                                                                "mechanism",
                                                                index
                                                              ),
                                                          },
                                                          attrs: {
                                                            type: "button",
                                                            role: "option",
                                                          },
                                                          on: {
                                                            mousedown:
                                                              function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.selectSuggestion(
                                                                  item
                                                                )
                                                              },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "rv2-welcome-sug-label",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.label
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          item.cfdeDisease
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "rv2-welcome-sug-meta",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        item.cfdeDisease
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "rv2-welcome-sug-kind",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Mechanism"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          !_vm.geneSuggestions.length &&
                                          !_vm.mechanismSuggestions.length
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "rv2-welcome-sug-status",
                                                },
                                                [_vm._v(" No matches ")]
                                              )
                                            : _vm._e(),
                                        ],
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "rv2-welcome-search-btn",
                              attrs: {
                                type: "button",
                                disabled:
                                  !_vm.searchText.trim() ||
                                  _vm.searchSubmitting,
                              },
                              on: { click: _vm.onSearchClick },
                            },
                            [_vm._v(" Search ")]
                          ),
                        ]),
                        _vm.searchError
                          ? _c(
                              "p",
                              { staticClass: "rv2-welcome-search-error" },
                              [_vm._v(_vm._s(_vm.searchError))]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
                _c(
                  "section",
                  {
                    staticClass: "rv2-welcome-section",
                    attrs: { "aria-labelledby": "rv2-welcome-import-title" },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "rv2-welcome-option rv2-welcome-option-import",
                        attrs: { type: "button" },
                        on: { click: _vm.onImportSessionClick },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "rv2-welcome-option-title",
                            attrs: { id: "rv2-welcome-import-title" },
                          },
                          [_vm._v(" Import session ")]
                        ),
                        _c("span", { staticClass: "rv2-welcome-option-desc" }, [
                          _vm._v(
                            " Load a previously exported session and pick up where you left off. "
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
                _c(
                  "section",
                  {
                    ref: "learnSection",
                    staticClass: "rv2-welcome-section",
                    attrs: { "aria-labelledby": "rv2-welcome-learn-title" },
                  },
                  [_vm._m(2)]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "rv2-welcome-head" }, [
      _c(
        "h2",
        {
          staticClass: "rv2-welcome-title",
          attrs: { id: "rv2-welcome-title" },
        },
        [
          _vm._v(" Welcome to "),
          _c("span", { staticClass: "rv2-welcome-brand" }, [
            _c("span", { staticClass: "rv2-welcome-mark" }, [_vm._v("REVEAL")]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "rv2-welcome-option-desc" }, [
      _vm._v(" Enter a gene symbol, a mechanism phrase, or both (e.g. "),
      _c("em", [_vm._v("FANCA DNA repair")]),
      _vm._v("). Autocomplete shows gene and mechanism options. "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rv2-welcome-option" }, [
      _c(
        "span",
        {
          staticClass: "rv2-welcome-option-title",
          attrs: { id: "rv2-welcome-learn-title" },
        },
        [_vm._v(" Learn REVEAL ")]
      ),
      _c("span", { staticClass: "rv2-welcome-option-desc" }, [
        _vm._v(
          " REVEAL helps you explore genes and disease mechanisms, inspect evidence, and carry curated findings into downstream analysis. Start with a gene or mechanism search, or import a saved session. "
        ),
      ]),
      _c("ul", { staticClass: "rv2-welcome-learn-list" }, [
        _c("li", [_vm._v("Search by gene symbol or mechanism phrase")]),
        _c("li", [_vm._v("Review mechanistic context and knowledge gaps")]),
        _c("li", [
          _vm._v("Save and reload your work with session import/export"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }